import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GeneralReportsService } from "src/app/services/general-reports/general-reports.service";
import { asBlob } from "html-docx-js-typescript";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';

@Component({
  selector: "app-general-report-page",
  templateUrl: "./general-report-page.component.html",
  styleUrls: ["./general-report-page.component.scss"],
})
export class GeneralReportPageComponent implements OnInit {
  public generalReport;
  public loader = true;
  public callsEntries = [];
  public callsSalientesMore = [];
  public callsSalientesLess = [];
  @ViewChild("htmlDoc") html;

  public globalMinutes = 0;
  public callEntriesMinutes = 0;
  public callSalientesMinutes = 0;
  public realTime = 0;
  public totalTimeCalls = ''
  public timeTotalOutgoinCallLess = '0 s.'
  public timeTotalOutgoinCallMore = '0 s.'
  public globalHoursFormatted: number = 0;
  public realHoursFormatted: number = 0;
  public realHoursText: string = '';

  constructor(
    private route: ActivatedRoute,
    private generalReportService: GeneralReportsService,
  ) { }

  async ngOnInit() {
    let timeCallEntries = 0;
    let timeCallSalientes = 0;
    this.globalMinutes = 0;
    let id = this.route.snapshot.params.id;
    this.generalReport = await this.generalReportService.getGeneralReportById(id);
    console.log("Reporte general:", this.generalReport);
    let llamadas_entrantes = JSON.parse(
      this.generalReport.call_report.call_answeredEntriesCalls
    );
    let llamadas_salientes = JSON.parse(
      this.generalReport.call_report.call_answeredSalientesCalls
    );
    Promise.all(
      llamadas_entrantes.map((element) => {
        timeCallEntries += element.duration;
        element.minutes = this.secondsToHms(element.duration);
        this.callsEntries.push(element);
      })
    );

    await Promise.all(
      llamadas_salientes.map((element) => {
        timeCallSalientes += element.duration;
        element.minutes = this.secondsToHms(element.duration);
        if (element.duration > 20) {
          this.callsSalientesMore.push(element);
        } else {
          this.callsSalientesLess.push(element);
        }
      })
    );
    var timeLessCalls = this.callsSalientesLess.map(call => call['duration']).reduce((total,value)=> total+value,0)
    this.timeTotalOutgoinCallLess = this.secondsToHms(timeLessCalls) ?? "0 s."
    var timeMoreCalls = this.callsSalientesMore.map(call => call['duration']).reduce((total,value)=> total+value,0)
    this.timeTotalOutgoinCallMore = this.secondsToHms(timeMoreCalls) ?? "0 s."

    this.generalReport.socialMediaEntries.forEach(entry => {
      if (entry.quantity > 0) {
        this.globalMinutes += entry.totalMinutes || 0;
        this.realTime += entry.realTotalMinutes || 0;
      }
    });
    
    this.globalHoursFormatted = this.minutesToHours(this.globalMinutes);
    this.realHoursFormatted = this.minutesToHours(this.realTime);
    this.realHoursText = this.minutesToHoursText(this.realTime);

    if (this.generalReport.additionalCalls) {
      this.generalReport.additionalCalls.forEach(additionalNumber => {
        additionalNumber.calls.forEach(call => {
          call['minutes'] = this.secondsToHms(call.duration)
          timeCallEntries += call.duration
        })
      })
    }
    if (this.generalReport?.outGoingCallPrefix) {
      this.generalReport.outGoingCallPrefix.forEach(prefixData => {
        prefixData['callMore'] = []
        prefixData['callLess'] = []
        prefixData.calls.forEach((call) => {
          call['minutes'] = this.secondsToHms(call.duration)
          timeCallSalientes += call.duration
          if (call.duration > 20) {
            prefixData['callMore'].push(call)
          } else {
            prefixData['callLess'].push(call)
          }
        })
      });
    }
    this.generalReport.call_report.total_TimeEntriesCalls = this.secondstoMns(timeCallEntries) || "0 s.";
    this.generalReport.call_report.total_TimeSalientesCalls = this.secondstoMns(timeCallSalientes) || "0 s.";
    this.totalTimeCalls = this.secondstoMns(timeCallEntries + timeCallSalientes) || "0 s."
  }

  viewPDF() {
    window.open(this.generalReport.pdfUrl, "_blank")
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hr. " : " hrs. ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min. " : " mins. ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " s." : " s.") : "";
    return hDisplay + mDisplay + sDisplay;
  }

  secondstoMns(d: number): string {
  
    d = Number(d);
    if (!d || d <= 0) return "0 s.";

    const m = Math.floor(d / 60);
    const s = Math.floor(d % 60);

    const mDisplay = m > 0 ? `${m} mins. ` : "";
    const sDisplay = s > 0 ? `${s} s.` : "";

    return (mDisplay + sDisplay).trim() || "0 s.";
  }

  async generateWord(element) {
    const htmlString = this.html.nativeElement.innerHTML;
    const data = await asBlob(htmlString, {
      orientation: "portrait",
      margins: { top: 300, bottom: 300 },
    })
    var url = window.URL.createObjectURL(data as Blob);
    this.download(url);
  }

  download(url) {
    var link = document.createElement('a');
    link.target = "_blank";
    link.download = `${this.generalReport?.report}_${this.generalReport?.clientName}.docx`;
    link.href = url;
    link.click();
    URL.revokeObjectURL(url);
  }

  minutesToHours(minutes: number): number {
    return minutes / 60;
  }

  minutesToHoursText(minutes: number): string {
    const h = Math.floor(minutes / 60);
    const m = Math.floor(minutes % 60);

    return `${h} hrs ${m} min`;
  }

  exportToExcel() {
    Swal.fire({
      position: 'center',
      title: 'Generando archivo, por favor espere...',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
    });

    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    const activities: any[] = [];

    this.generalReport?.socialMediaEntries?.forEach((item: any) => {
      if (item.quantity > 0) {
        activities.push({
          Tarea: item.title,
          Cantidad: item.totalAll,
          'Minutos actividad': item.minutes,
          'Tiempo': item.realTotalMinutes
        });
      }
    });

    activities.push({
      Tarea: 'TOTAL',
      Cantidad: '',
      'Minutos actividad': '',
      'Tiempo': this.realTime
    });

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(activities),
      'Actividades'
    );

    const logs: any[] = [];

    this.generalReport?.activities?.forEach((item: any) => {
      logs.push({
        Fecha: item.date?.toDate ? item.date.toDate() : item.date,
        Acción: item.text,
        'Total acciones': item.totalActions,
        'Tiempo': (item.timeTask || 2)?.toFixed(2),
        Comentarios: item.comments
      });
    });

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(logs),
      'Registro actividades'
    );

    const incomingCalls: any[] = [];

    this.callsEntries?.forEach((call: any) => {
      incomingCalls.push({
        Fecha: call.calldate,
        Origen: call.callerId,
        'Duración (s)': call.duration,
        Duración: call.minutes
      });
    });

    this.generalReport?.additionalCalls?.forEach((additional: any) => {
      additional.calls?.forEach((call: any) => {
        incomingCalls.push({
          Fecha: call.calldate,
          Origen: additional.number,
          'Duración (s)': call.duration,
          Duración: call.minutes
        });
      });
    });

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(incomingCalls),
      'Llamadas entrantes'
    );
    
    const outgoingCalls: any[] = [];

    // llamadas salientes principales
    this.callsSalientesLess?.forEach((call: any) => {
      outgoingCalls.push({
        Fecha: call.calldate,
        Destino: call.destino?.slice ? call.destino.slice(4) : call.destino,
        'Duración (s)': call.duration,
        Duración: call.minutes,
        Estado: call.state === 'ANSWERED' ? 'Respondida' : 'Perdida',
        Prefijo: 'Principal'
      });
    });

    this.callsSalientesMore?.forEach((call: any) => {
      outgoingCalls.push({
        Fecha: call.calldate,
        Destino: call.destino?.slice ? call.destino.slice(4) : call.destino,
        'Duración (s)': call.duration,
        Duración: call.minutes,
        Estado: call.state === 'ANSWERED' ? 'Respondida' : 'Perdida',
        Prefijo: 'Principal'
      });
    });

    // llamadas por prefijo
    this.generalReport?.outGoingCallPrefix?.forEach((prefix: any) => {
      prefix.callLess?.forEach((call: any) => {
        outgoingCalls.push({
          Fecha: call.calldate,
          Destino: call.destino?.slice ? call.destino.slice(4) : call.destino,
          'Duración (s)': call.duration,
          Duración: call.minutes,
          Estado: call.state === 'ANSWERED' ? 'Respondida' : 'Perdida',
          Prefijo: prefix.prefix
        });
      });

      prefix.callMore?.forEach((call: any) => {
        outgoingCalls.push({
          Fecha: call.calldate,
          Destino: call.destino?.slice ? call.destino.slice(4) : call.destino,
          'Duración (s)': call.duration,
          Duración: call.minutes,
          Estado: call.state === 'ANSWERED' ? 'Respondida' : 'Perdida',
          Prefijo: prefix.prefix
        });
      });
    });

    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(outgoingCalls),
      'Llamadas salientes'
    );

    XLSX.writeFile(
      wb,
      `${this.generalReport?.report}_${this.generalReport?.clientName}.xlsx`
    );

    Swal.close();
  }

}
